export default function _identity(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_identity.js
// module id = 284
// module chunks = 1